export default __webpack_public_path__ + "static/media/icon-coin-pivx.8c403ec9.svg";